const log = [
  {
    path: "/log/manage",
    name: "logManage",
    component: () => import("@/view/log/manage"),
  },
];
export default log;
